import { Component } from 'react';

// Scoped safety net for the chat widget. React's default behavior on an
// uncaught render-phase error is to unmount the ENTIRE tree it belongs to -
// with no boundary anywhere in this app, a bug inside DevarshAgent (e.g. a
// malformed topic-card object reaching renderTopicCard) would take the whole
// site down to the bare <body> background (#0a0a0a, i.e. "the website goes
// black"), not just the chat panel. Wrapping just <DevarshAgent /> in this
// boundary means a future bug in the chatbot degrades to "chat widget shows
// a fallback" instead of "entire portfolio disappears."
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('DevarshAgent crashed and was contained by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
